import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { Button } from 'antd';
import { GrSearch } from "react-icons/gr";
import { GrColumns } from "react-icons/gr";
import { useCoworkerRequestContext } from '../contexts/coworkerRequestProvider';
import { usePropertyContext } from '../contexts/propertyProvider';
import Loader from './common/Loader';
import ErrorAlert from './common/ErrorAlert';
import { logOutUrl } from './common/utils';

const Header = ({ nickname, translate }) => {
  const navigate = useNavigate();

  const {
    isLoading: isLoadingCoworkerData,
    error: errorCoworkerData,
    isApprovedCoworker,
    workSpaceEmail
  } = useCoworkerRequestContext();

  const {
    data: propertyData,
    isLoading: isPropertyLoading,
    error: errorProperty
  } = usePropertyContext([]);

  return (
    <div className="header-container">
      <div className="header-wrap">
        <div className="left-layout">
          {propertyData?.length ? ( // only show view select if properties exist. "Add first property" message is shown only in TimeLine view.
            <>
              <Button
                className="changeViewButton"
                type="text"
                icon={<GrColumns />}
                title={translate('timelineView')}
                onClick={() => navigate("/app")}
              />
              <Button
                className="changeViewButton"
                type="text"
                icon={<GrSearch />}
                title={translate('quickSearch')}
                onClick={() => navigate("/search-view")}
              />
            </>
          ) : null}
        </div>
        <div className="right-layout">
          <p className="nickname">{nickname} {isApprovedCoworker && `(${workSpaceEmail})`}</p>
          <a className="logout-button" href={logOutUrl}>{translate('logout')}</a>
        </div>
      </div>
      <Loader 
        setIsLoading={isLoadingCoworkerData || isPropertyLoading}
      />
      <ErrorAlert
        error={errorCoworkerData || errorProperty}
        className={'header-error-alert'}
      />
    </div>
  );
};

Header.propTypes = {
  nickname: PropTypes.string,
  translate: PropTypes.func
};

export default Header;
